(function() {
  if (!customElements.get('jc-megamenu')) {
    customElements.define('jc-megamenu', class extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }
      }
    });
  }

  function waitForData(cb) {
    if (window.jcMenuData) {
      cb(window.jcMenuData);
    } else {
      setTimeout(function() { waitForData(cb); }, 100);
    }
  }

  function buildHTML(data) {
    var sidebarHTML = '<p class="jc-sidebar__label">Par catégorie</p>';
    data.categories.forEach(function(cat, i) {
      sidebarHTML += '<button class="jc-sb' + (i === 0 ? ' active' : '') + '" data-target="' + cat.id + '">'
        + cat.label + ' <span>›</span></button>';
    });

    var panelsHTML = '';
    data.categories.forEach(function(cat, i) {
      panelsHTML += '<div class="jc-panel' + (i === 0 ? ' active' : '') + '" id="jc-' + cat.id + '">'
        + '<p class="jc-panel__title">' + cat.label + '</p>'
        + '<ul class="jc-grid">';
      cat.links.forEach(function(link) {
        panelsHTML += '<li><a href="' + link.url + '"><span class="jc-dot"></span>' + link.label + '</a></li>';
      });
      panelsHTML += '</ul>';
      if (cat.cards && cat.cards.length) {
        panelsHTML += '<div class="jc-cards">';
        cat.cards.forEach(function(card) {
          panelsHTML += '<a href="' + card.url + '" class="jc-card">'
            + '<span class="jc-card__tag">' + card.tag + '</span>'
            + '<span class="jc-card__title">' + card.title + '</span>'
            + '<span class="jc-card__desc">' + card.desc + '</span>'
            + '</a>';
        });
        panelsHTML += '</div>';
      }
      panelsHTML += '</div>';
    });

    var cadeauxHTML = '<p class="jc-panel__title">Offrir un bijou</p><ul class="jc-grid">';
    data.cadeaux.forEach(function(item) {
      cadeauxHTML += '<li><a href="' + item.url + '"><span class="jc-dot"></span>' + item.label + '</a></li>';
    });
    cadeauxHTML += '</ul>';

    document.querySelectorAll('jc-megamenu').forEach(function(el) { el.remove(); });
    var host = document.createElement('jc-megamenu');
    host.innerHTML = '<div class="jc-bd" id="jc-bd"></div>'
      + '<div class="jc-mega" id="jc-mega-collections">'
      + '<div class="jc-mega__inner">'
      + '<div class="jc-sidebar">' + sidebarHTML + '</div>'
      + '<div class="jc-content">' + panelsHTML + '</div>'
      + '</div></div>'
      + '<div class="jc-simple" id="jc-mega-cadeaux">' + cadeauxHTML + '</div>';

    document.body.appendChild(host);
    bindEvents();
  }

  function bindEvents() {
    setTimeout(function() {
      var tc = document.getElementById('jc-trigger-collections');
      var td = document.getElementById('jc-trigger-cadeaux');
      var mc = document.getElementById('jc-mega-collections');
      var md = document.getElementById('jc-mega-cadeaux');
      var bd = document.getElementById('jc-bd');

      if (!tc || !mc || !bd) {
        setTimeout(arguments.callee, 300);
        return;
      }

      function getBottom() {
        var h = document.querySelector('header-component, .header-section');
        return h ? h.getBoundingClientRect().bottom : 80;
      }

      function open(mega) {
        [mc, md, bd].forEach(function(el) { el && el.classList.remove('jc-open'); });
        mega && mega.classList.add('jc-open');
        bd && bd.classList.add('jc-open');
        if (mega) {
          var mw = mega.offsetWidth || 820;
          mega.style.top = getBottom() + 'px';
          mega.style.left = Math.max(16, (window.innerWidth - mw) / 2) + 'px';
        }
      }

      function closeAll() {
        [mc, md, bd].forEach(function(el) { el && el.classList.remove('jc-open'); });
      }

      tc.addEventListener('mouseenter', function() { open(mc); });
      td && td.addEventListener('mouseenter', function() { open(md); });

      var closeTimer = null;
      document.addEventListener('mouseover', function(e) {
        if (!mc.classList.contains('jc-open') && !md.classList.contains('jc-open')) return;
        var inTrigger = e.target.closest('.jc-nav-trigger');
        var inMega = e.target.closest('jc-megamenu');
        if (inTrigger || inMega) {
          clearTimeout(closeTimer);
        } else {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(closeAll, 150);
        }
      });

      /* CORRECTION : le backdrop ne bloque les clics QUE quand le mega menu est ouvert */
      bd.style.pointerEvents = 'none';
      bd.addEventListener('click', closeAll);

      /* Quand le mega s'ouvre, activer le backdrop */
      var observer = new MutationObserver(function() {
        if (bd.classList.contains('jc-open')) {
          bd.style.pointerEvents = 'auto';
        } else {
          bd.style.pointerEvents = 'none';
        }
      });
      observer.observe(bd, { attributes: true, attributeFilter: ['class'] });

      /* Fermer le mega quand on clique sur la loupe */
      document.addEventListener('click', function(e) {
        if (e.target.closest('.search-action') || e.target.closest('search-modal') || e.target.closest('[data-action="open-search"]')) {
          closeAll();
        }
      });

      document.querySelectorAll('#jc-mega-collections .jc-sb').forEach(function(btn) {
        btn.addEventListener('mouseenter', function() {
          document.querySelectorAll('#jc-mega-collections .jc-sb').forEach(function(b) { b.classList.remove('active'); });
          document.querySelectorAll('#jc-mega-collections .jc-panel').forEach(function(p) { p.classList.remove('active'); });
          btn.classList.add('active');
          var panel = document.getElementById('jc-' + btn.dataset.target);
          if (panel) panel.classList.add('active');
        });
      });

      window.addEventListener('scroll', function() {
        if (mc.classList.contains('jc-open')) open(mc);
        if (md.classList.contains('jc-open')) open(md);
      }, { passive: true });

      var mobileBtn = document.getElementById('jc-mobile-btn');
      var mobileDrawer = document.getElementById('jc-mobile-drawer');
      var mobileOverlay = document.getElementById('jc-mobile-overlay');
      var mobileClose = document.getElementById('jc-mobile-close');

      if (mobileBtn) {
        mobileBtn.addEventListener('click', function() {
          mobileDrawer.classList.add('open');
          mobileOverlay.classList.add('open');
        });
        mobileClose && mobileClose.addEventListener('click', function() {
          mobileDrawer.classList.remove('open');
          mobileOverlay.classList.remove('open');
        });
        mobileOverlay && mobileOverlay.addEventListener('click', function() {
          mobileDrawer.classList.remove('open');
          mobileOverlay.classList.remove('open');
        });
      }

      console.log('Mega menu Jewelry Celeste — prêt !');
    }, 200);
  }

  if (document.readyState === 'complete') {
    waitForData(buildHTML);
  } else {
    window.addEventListener('load', function() {
      waitForData(buildHTML);
    });
  }

})();
